var map = {
	"./p1.png": "5cxE",
	"./p10.png": "Mwgk",
	"./p11.png": "kVhH",
	"./p12.png": "+5R3",
	"./p2.png": "N5Fo",
	"./p3.png": "gQwM",
	"./p4.png": "UpqR",
	"./p5.png": "2kUr",
	"./p6.png": "eCXK",
	"./p7.png": "XHD4",
	"./p8.png": "FLU7",
	"./p9.png": "7YiS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5QJM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner ^\.\/p.*\.png$
// module id = 5QJM
// module chunks = 0